<template>
  <Modal v-model="isShow" width="400" :footer-hide="true" :closable="false" :mask-closable="false" v-if="!hasCustomRelogin" class-name="relogin-modal">
    <!-- v-if="!hasCustomRelogin" -->
    <span class="title">需要重新登录</span>
    <Form label-position="right" class="from_relogin" :label-width="0" @submit.native.prevent>
      <!-- <FormItem label="用户名" style="margin-bottom:16px;font-size:14px">
        <span>{{ username }}</span>
      </FormItem>-->
      <!-- <FormItem label style="margin-bottom:25px;font-size:14px">
        <Input type="text" v-model="username" placeholder="Username" class="relogin_input" >
          <Icon type="ios-person-outline" style="font-size:21px" slot="prepend"></Icon>
        </Input>
      </FormItem> -->
      <FormItem label style="margin-bottom:20px;font-size:14px">
        <Input class="relogin_input" v-model="password" type="password" placeholder="请输入密码重新登录" clearable @on-enter="login">
        <Icon type="ios-lock-outline" style="font-size:21px" slot="prepend"></Icon>
        </Input>
      </FormItem>
      <!-- <FormItem label="" style="margin-bottom:16px;font-size:14px">
        <Input
          v-model="password"
          type="password"
          placeholder="输入密码重新登录"
          clearable
          @on-enter="login"
        />
      </FormItem>-->
      <FormItem>
        <Button type="primary" class="btn-login" size="large" style="margin:10px 0;" :loading="loginLoading" @click="login" long>确定</Button>
      </FormItem>
    </Form>
  </Modal>
  <component v-else-if="isShow && hasCustomRelogin" v-bind:is="customRelogin"></component>
</template>
<script>

export default {
  created() {
    let _this = this
    _this.customRelogin = _this.$app.Override ? _this.$app.Override.relogin : false //加载被重写的relogin组件
  },
  data() {
    return {
      loginLoading: false,
      customRelogin: "",
      password: "",
    }
  },
  computed: {
    username() {
      return this.$store.state.core.user.username
    },
    isShow: {
      get() {
        return this.$store.state.core.relogin
      },
      set(val) {
        this.$store.commit("core/setRelogin", val)
      },
    },
    isRefresh() {
      return this.$store.state.core.reloginRefresh === true
    },
    hasCustomRelogin() {
      return !!this.customRelogin
    },
  },
  methods: {
    async login() {
      let _this = this
      if (_this.loginLoading) return
      if (_this.password) {
        _this.loginLoading = true
        let _form = {}
        let password = _this.password
        // if (_this.$app.ProjSetting.isCryptoLoginPWD) {
        //   password = enctyptLoginPWD(password)
        // }
        let macid = ""
        if (typeof plus != "undefined" && plus.macid == undefined) {
          macid = await new Promise(function (res, rej) {
            plus.device.getInfo({
              success: function (e) {
                res(e.uuid)
              },
            })
          })
          // plus.macid = macid;
          if (macid) plus.storage.setItem("macid", macid)
        }
        _this.$curl
          .post("/api/public/core/login", {
            username: _this.username,
            password,
            remember: false,
            macid: macid,
          })
          .then((res) => {
            _this.isShow = false
            _this.$Message.info("登录成功")
            if (this.isRefresh) {
              location.reload()
            }
          })
          .finally(() => {
            _this.loginLoading = false
            _this.password = ""
          })
      } else {
        _this.$Message.warning("请输入密码")
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.title {
  margin-bottom: 35px;
  text-align: center;
  display: block;
  font-size: 20px;
  font-weight: bold;
}
.ivu-form-item {
  margin-bottom: 12px;
  &:last-of-type {
    margin-bottom: 6px;
  }
}
</style>
<style lang="scss">
.relogin-modal {
  .ivu-modal {
    top: 28%;
  }
  .ivu-modal-body {
    padding: 35px 65px;
  }
}
.from_relogin.ivu-form {
  .ivu-form-item-label {
    font-size: 15px;
    font-weight: bold;
  }
  .ivu-input-group .ivu-input {
    height: 40px;
  }
}
</style>